import React, { useEffect, useRef, useState } from "react";
import { typography, surfaces, borders, textColors } from "../../design-system/tokens";

// Reusable info icon with hover + click-to-persist behavior
// - Shows tooltip on hover
// - On click, keeps tooltip visible for 3 seconds
// - While pressed/hovered, stays visible
export default function InfoIcon({ text }) {
  const [isHovered, setIsHovered] = useState(false);
  const [isPinned, setIsPinned] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  if (!text) return null;

  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    setIsPinned(true);
    timerRef.current = setTimeout(() => {
      setIsPinned(false);
    }, 3000);
  };

  const showTooltip = isHovered || isPinned;

  return (
    <span className="relative inline-block align-middle">
      <button
        type="button"
        className={`inline-flex items-center justify-center w-4 h-4 rounded-full border ${borders.strong} ${textColors.muted} text-[10px] leading-none ${surfaces.elevated} cursor-help select-none`}
        aria-label="More info"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onMouseDown={() => setIsHovered(true)}
        onMouseUp={() => setIsHovered(false)}
        onClick={handleClick}
      >
        i
      </button>
      {showTooltip && (
        <div
          role="tooltip"
          className={`absolute top-0 left-1/2 -translate-x-1/2 sm:left-5 sm:translate-x-0 z-50 px-3 py-2 rounded bg-gray-800 dark:bg-dark-900 !text-white ${typography.caption} shadow w-[min(20rem,calc(100vw-24px))] sm:w-80`}
          style={{ whiteSpace: "normal" }}
        >
          {text}
        </div>
      )}
    </span>
  );
}


